export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, HardTokenResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.HardTokenResource = HardTokenResource;
    }

    $onInit() {
        this.companyUser = this.resolve.companyUser;
        this.companyId = this.resolve.companyId;
        this.token = this.resolve.token;
    }

    assingTokenSecondary(){
        this.HardTokenResource
            .assingTokenAsSecondary(this.companyId,this.companyUser.id,this.token.id)
            .then((data) => {
                this.$state.reload('company.user-directories.manage-user');
                this.Alert('success', 'company.user-directories.manage-user.device_assigned');
            })
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/assign-hard-token/confirm-assign/confirm-assign.controller.js